import React, { useEffect, useState } from "react";
import api from '../../services/api';
import { useNavigate, useParams } from "react-router-dom";

const DeleteComplain = () => {
  const { complainID } = useParams(); // Get complainID from URL
  const [complain, setComplain] = useState(null);
  const [applicant, setApplicant] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Fetch complain details
        const complainResponse = await api.get(`/Complains/${complainID}`);
        setComplain(complainResponse.data);
  
        // 2. Fetch applicant details if applicantID exists
        if (complainResponse.data.applicantID) {
          try {
            const applicantResponse = await api.get(`/applicants/${complainResponse.data.applicantID}`);
            setApplicant(applicantResponse.data);
          } catch (applicantError) {
            console.error("Error fetching applicant details:", {
              message: applicantError.message,
              status: applicantError.response?.status,
              data: applicantError.response?.data
            });
          }
        }
      } catch (complainError) {
        console.error("Error fetching complain details:", {
          message: complainError.message,
          status: complainError.response?.status,
          data: complainError.response?.data
        });
      }
    };
  
    fetchData();
  }, [complainID]);

  const handleDelete = async () => {
    if (!complain) return;

    if (window.confirm("Are you sure you want to delete this complain?")) {
      await onDelete(complain.complainID);
    }
  };

  const onDelete = async (complainID) => {
    try {
      await api.delete(`/Complains/${complainID}`);
      navigate("/complains/complainlist");
      
    } catch (error) {
      const errorMessage = error.response?.data?.message 
        || error.message 
        || 'Failed to delete complain';
      
      console.error("Error deleting complain:", {
        error: error.response?.data || error.message,
        status: error.response?.status
      });
    }
  };

  if (!complain) {
    return <p>Loading complain details...</p>;
  }

  return (
    <div className="container mt-4" style={{ maxWidth: "625px" }}>
      <h5 className="es-label-title">Delete Complain</h5>
      <div className="card p-3">
        <div className="row mb-1">
          <div className="col-md-6">
          <div className="es-field-label-black" style={{ lineHeight: "1.6" }}>
            <p style={{ marginBottom: "5px" }}>Full Name : <strong style={{ paddingLeft: "33px" }}>{applicant ? applicant.fullName : "Loading..."}</strong></p>
            <p style={{ marginBottom: "5px" }}>Passport No : <strong style={{ paddingLeft: "22px" }}>{applicant ? applicant.passportNo : "Loading..."}</strong></p>
            <p style={{ marginBottom: "5px" }}>Gender : <strong style={{ paddingLeft: "52px" }}>{applicant ? applicant.gender : "Loading..."}</strong></p>
            <p style={{ marginBottom: "5px" }}>Occupation : <strong style={{ paddingLeft: "28px" }}>{applicant ? applicant.occupation : "Loading..."}</strong></p>
            <p style={{ marginBottom: "5px" }}>Complained By : <strong style={{ paddingLeft: "5px" }}>{complain.complainedBy}</strong></p>
            <p style={{ marginBottom: "5px" }}>Phone No. : <strong style={{ paddingLeft: "35px" }}>{complain.contactPhone}</strong></p>
            <p style={{ marginBottom: "5px" }}>Relation : <strong style={{ paddingLeft: "46px" }}>{complain.relation}</strong></p>
            <p style={{ marginBottom: "5px" }}>Type : <strong style={{ paddingLeft: "69px" }}>{complain.complainType}</strong></p>
            <p style={{ marginBottom: "5px" }}>Description : <strong style={{ paddingLeft: "27px" }}>{complain.description}</strong></p>
            <p style={{ marginBottom: "5px" }}>Status : <strong style={{ paddingLeft: "57px" }}>{complain.status}</strong></p>
          </div>

          </div>
          <div className="col-md-6 d-flex justify-content-center">
            {applicant && (
              <div className="p-1 bg-gray-100 rounded">
                {applicant?.photo && (
                  <img
                    src={`data:image/jpeg;base64,${applicant.photo}`}
                    alt="Applicant Photo"
                    className="rounded-full"
                    style={{ width: "135px", height: "140px", borderColor: "darkgray", borderStyle: "solid", borderWidth: "thin" }} // Adjust size as needed
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-end">
          <button onClick={handleDelete} className="btn es-button-danger">
            DELETE
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteComplain;
